import React from 'react';
import DatePicker from "react-datepicker";
import moment from 'moment'
import 'date-fns';
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBInput,
    MDBBtn,
    MDBModalFooter,
    MDBModal,
    MDBModalBody
} from 'mdbreact';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import axios from 'axios';
//import logo from '../radiologie-muenchen.png';

const API_PATH = window.location.protocol+'//'+window.location.hostname+'/php/includes/signIn.php';
//const API_PATH = "https:"+'//'+window.location.hostname+'/php/includes/signIn.php';


class RegistroDoctoresForm extends React.Component {

    constructor(props) {
        super(props);
        this.dataform = {
            kv: '',
            treatment: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            job_title: '',
            birth_date: '',
            city: '',
            postal_code: '',
            primary_specialty: '',
            email:'',
            second_email: '',
            password:'',
            secondpassword:'',
            pass:'',
            phone: ''
        };

        this.state = {
            showAlert: false,
            errorMessage:"User has not been created correctly",
            sentMessage:"Congratulations!! Your user has been created. To complete your Register process you have to validate it, by clicking the link has been sent to your email inbox",
            mailSent:false,
            selectedClass:'notSelected',
            showValidation:false,
            validationMessage:"Some fields are incorrect. Review your information.",
            selectedDate: new Date(),

            lang:{
                header_text:"",
                requitedfields_text:"",
                kv_text:"",
                treatment_text:"",
                firstname_text:"",
                middlename_text:"",
                lastname_text:"",
                jobtitle_text:"",
                birthdate_text:"",
                city_text:"",
                postalcode_text:"",
                primaryspecialty_text:"",
                email_text:"",
                secondemail_text:"",
                passwordinfo_text:"",
                password_text:"",
                secondpassword_text:"",
                phone_text:"",
                signin_text:"",
            }

        };
        this.errorMessage = '';

        this.handleKvChange = this.handleKvChange.bind(this);
        this.handleTreatmentChange = this.handleTreatmentChange.bind(this);
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleMiddleNameChange = this.handleMiddleNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleJobTitleChange = this.handleJobTitleChange.bind(this);
        this.handleBirthdateChange = this.handleBirthdateChange.bind(this);
        this.handleCityChange = this.handleCityChange.bind(this);
        this.handlePostalCodeChange = this.handlePostalCodeChange.bind(this);
        this.handlePrimarySpecialtyhange  = this.handlePrimarySpecialtyhange.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleSecondEmailChange = this.handleSecondEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleSecondPasswordChange = this.handleSecondPasswordChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);

    }
    getLang(){

        var pathname = window.location.pathname;
        var alias_array = pathname.split( '/' );
        var last_segment = alias_array.pop();
        var alias = last_segment;
        if(alias=="") {
            alias = alias_array[alias_array.length-1];
        }

        var lang = "de.json";
        switch(alias){
            case 'doctor':
                lang = "en.json";
                break;
            case 'doctores':
                lang = "es.json";
                break;
            case 'doktor':
                lang = "de.json";
                break;
        }
        const myRequest = new Request(process.env.REACT_APP_RESOURCES_PATH+'doctor/lang/'+lang);
        fetch(myRequest)
            .then(response => response.json())
            .then(data=>{
                this.setState({
                    lang:{
                        header_text:data.header_text,
                        requitedfields_text:data.requitedfields_text,
                        kv_text:data.kv_text,
                        treatment_text:data.treatment_text,
                        firstname_text:data.firstname_text,
                        middlename_text:data.middlename_text,
                        lastname_text:data.lastname_text,
                        jobtitle_text:data.jobtitle_text,
                        birthdate_text:data.birthdate_text,
                        city_text:data.city_text,
                        postalcode_text:data.postalcode_text,
                        primaryspecialty_text:data.primaryspecialty_text,
                        email_text:data.email_text,
                        secondemail_text:data.secondemail_text,
                        passwordinfo_text:data.passwordinfo_text,
                        password_text:data.password_text,
                        secondpassword_text:data.secondpassword_text,
                        phone_text:data.phone_text,
                        signin_text:data.signin_text
                    }
                })
            });
    }

    componentDidMount(){
        this.getLang();
    }

    handleKvChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.kv = event.target.value;
        }
    }
    handleTreatmentChange(event) {
        event.target.isValid=true;
        this.dataform.treatment = event.target.options[event.target.selectedIndex].text;
        this.setState({
            selectedClass:"treatmentSelected"
        });
    }
    handleTreatmentFocused(event){
        document.getElementById("TreatmentLabel").classList.add("active");
    }
    handleFirstNameChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.first_name = event.target.value;
        }
    }
    handleMiddleNameChange(event) {
        this.dataform.middle_name = event.target.value;
    }
    handleLastNameChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
            event.target.className +=" is-invalid"
        }else{
            event.target.isValid=true;
            this.dataform.last_name = event.target.value;
        }

    }
    handleJobTitleChange(event) {
        this.dataform.job_title = event.target.value;
    }
    handleBirthdateChange = date => {
        this.setState({
            selectedDate: date
        });
    };
    handleCityChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.city = event.target.value;
        }
    }
    handlePostalCodeChange(event) {
        if(event.target.value==""){
            event.target.isValid=false;
        }else{
            event.target.isValid=true;
            this.dataform.postal_code = event.target.value;
        }
    }
    handlePrimarySpecialtyhange(event) {
        this.dataform.primary_specialty = event.target.value;
    }
    handleEmailChange(event) {

        let lastAtPos = event.target.value.lastIndexOf('@');
        let lastDotPos = event.target.value.lastIndexOf('.');

        if (!(lastAtPos < lastDotPos && lastAtPos > 0 && event.target.value.indexOf('@@') == -1 && lastDotPos > 2 && (event.target.value.length - lastDotPos) > 2)) {
            if(event.target.className.indexOf("is-invalid")<0){
                event.target.className += " is-invalid";

                event.target.isValid=false;
            }
        }else{
            event.target.className = event.target.className.replace("is-invalid","");
            event.target.isValid=true;
            this.dataform.email = event.target.value;
        }
    }
    handleSecondEmailChange(event) {

        if(this.dataform.email != event.target.value) {
            if(event.target.className.indexOf("is-invalid")<0){
                event.target.className += " is-invalid";
                event.target.isValid=false;
            }
        }else{
            event.target.className = event.target.className.replace("is-invalid","");
            this.dataform.email = event.target.value;
            event.target.isValid=true;
        }
        this.dataform.second_email = event.target.value;
    }
    handlePasswordChange(event) {

        var pass=event.target.value;
        var passLen=10;
        var exp = '^(?=.*[A-Z].*)(?=.*[!@#$&*])(?=.*[0-9].*)(?=.*[a-z].*).{len,}$';
        var str2 = exp.replace('len', passLen);
        var strongPass = new RegExp(str2);

        var isStrong= strongPass.exec(pass);

        if(isStrong){
            event.target.className = event.target.className.replace("is-invalid","");
            this.dataform.password = event.target.value;
            event.target.isValid=true;

        }else{
            if(event.target.className.indexOf("is-invalid")<0){
                event.target.className += " is-invalid";

                event.target.isValid=false;
            }

            //return false;
        }


    }
    handleSecondPasswordChange(event) {

        if(this.dataform.password != event.target.value) {
            if(event.target.className.indexOf("is-invalid")<0){
                event.target.className += " is-invalid";
                event.target.isValid=false;
            }
        }else{
            event.target.className = event.target.className.replace("is-invalid","");
            this.dataform.password = event.target.value;
            event.target.isValid=true;
        }
        this.dataform.secondpassword = event.target.value;
    }
    handlePhoneChange(event) {
        this.dataform.phone = event.target.value;
    }
    handleSubmit(event) {

        event.preventDefault();
        event.target.className += " was-validated";
        //event.target.isValid=true;




        var components=document.getElementsByClassName("form-control");
        var inputList = Array.prototype.slice.call(components);
        let formIsValid = true;
        console.log("Componentes =",components);
        inputList.forEach(function(component){
            if(component.required){
                if(!component.isValid){
                    //console.log("Componente inválido ",component);
                    event.target.className += " is-invalid";
                    formIsValid=false;
                }else{
                    //console.log("Componente válido");
                }
            }

        });
        if(formIsValid){
            this.submitForm();
        }else{
            this.setState({
                showValidation: true
            });
        }

       /* var success = true;

        if(this.dataform.password != this.dataform.secondpassword) {
            success = false;
            //this.errorMessage = "Error verifying password";
            this.setState({
                showAlert: !this.state.showAlert
            });
        }else{

            var pre = '13432FStS';
            var end = 'a';
            var newPassword=pre + btoa( this.dataform.password) + end;

/!*

            var getParams = document.URL.split("?");
            var params = Ext.Object.fromQueryString(getParams[getParams.length - 1]);
            var data = {
                rpt:params['rpt'],
                np:newPassword
            };




            var md5Value = this.codificarValor('md5', this.dataform.password);
            var base64Value = this.codificarValor('base64', md5Value);*!/
            this.dataform.pass = newPassword;
            this.dataform.password = null;
            this.dataform.secondpassword = null;
            this.sendInfo();
        }
        event.preventDefault();*/
    }
    submitForm(){
        var success = true;

        if(this.dataform.password != this.dataform.secondpassword) {
            success = false;
            //this.errorMessage = "Error verifying password";
            this.setState({
                showAlert: !this.state.showAlert
            });
        }else{

            var pre = '13432FStS';
            var end = 'a';
            var newPassword=pre + btoa( this.dataform.password) + end;

            this.dataform.pass = newPassword;
            this.dataform.password = null;
            this.dataform.secondpassword = null;
            this.dataform.birth_date=moment(this.state.selectedDate).format('L');
            this.sendInfo();
        }
    }
    sendInfo(){
        axios({
            method: 'post',
            url: `${API_PATH}`,
            crossdomain: true,
            headers: { 'content-type': 'application/json' },
            data: this.dataform
        }).then(result => {
            if(result.status==200){
                if(result.data.success){
                    this.setState(
                        { mailSent: true }
                    );

                }else{
                    this.setState(
                        {
                            showSQLAlert:true,
                            sqlErrorMessage: this.parseSqlError(result.data)
                        }
                    )
                }
            }else{
                this.setState(
                    {
                        error: result.data.message,
                        showAlert:true
                    }
                )
            }
        }).catch(error => {
                this.setState(
                    {
                        error: error.message,
                        showAlert:true
                    }
                )
            }
        );
    }
    handleNotShowMessage(){
        console.log("NOT SHOWING");
        this.setState({
            showAlert: false
        });
    }

    toggle = () => {
        this.setState({
            showAlert: !this.state.showAlert
        });
    };
    toggleMail = () => {
        this.setState({
            mailSent:  !this.state.mailSent,
        });
    };
    toggleSql = () => {
        this.setState({
            showSQLAlert:  !this.state.showSQLAlert,
        });
    };
    toggleValidation = () => {
        this.setState({
            showValidation:  !this.state.showValidation,
        });
    };

    render() {
        const { t } = this.props;
        document.title = "";
      return (
          <div className="row d-flex justify-content-center">
            <div className="col-md-8 modal-lg">
                <MDBContainer>
                    <MDBModal isOpen={this.state.mailSent} toggle={this.toggleMail} size="lg" centered>
                        <MDBModalBody>
                            <img className="successImage" src={ '../greenStick.svg.png'} />
                            {this.state.sentMessage}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={this.toggleMail}>Close</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                </MDBContainer>

                <MDBContainer>
                    <MDBModal isOpen={this.state.showSQLAlert} toggle={this.toggleSql} side position="top-right" dismiss>
                        <MDBModalBody>
                            {this.state.sqlErrorMessage}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={this.toggleSql}>Close</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                </MDBContainer>
                <MDBContainer>
                    <MDBModal isOpen={this.state.showValidation} toggle={this.toggleValidation} side position="top-right" dismiss>
                        <MDBModalBody>
                            {this.state.validationMessage}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={this.toggleValidation}>Close</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                </MDBContainer>

                    <MDBContainer>
                        <MDBModal isOpen={this.state.showAlert} toggle={this.toggle} side position="top-right" dismiss>
                            <MDBModalBody>
                                <img className="successImage" src={ '../Error_icon_512x512.png'} />
                                {this.state.errorMessage}
                            </MDBModalBody>
                            <MDBModalFooter>
                                <MDBBtn color="secondary" onClick={this.toggle}>Close</MDBBtn>
                            </MDBModalFooter>
                        </MDBModal>
                    </MDBContainer>
              <form className="istForm needs-validation"
                    onSubmit={this.handleSubmit}
                    noValidate
              >
                <MDBContainer>
                    <MDBRow>
                      <MDBCol>
                        <MDBCard>
                          <MDBCardBody className="mx-4">
                              <img className="logo" src={'../radiologie-muenchen.png'} />
                            <div className="text-center">
                              <h3 className="dark-grey-text mb-5">
                                <strong>{this.state.lang.header_text}</strong>
                              </h3>
                            </div>
                              <label htmlFor="defaultFormCardEmailEx" className="blue-text font-weight-light pequeña no-bottom">
                                  {this.state.lang.requitedfields_text}
                              </label>
                              <MDBInput
                                  type="text"
                                  label={this.state.lang.kv_text}
                                  name="kv"
                                  onChange={this.handleKvChange}
                                  className="form-control"
                              />
                              <div className="md-form">
                                  <select className={this.state.selectedClass + " browser-default custom-select treatment-select"} name="treatment" onChange={this.handleTreatmentChange}  onFocus={this.handleTreatmentFocused}>
                                      <option hidden disabled selected value></option>
                                      <option value="1">Dr.</option>
                                      <option value="2">Dr. med.</option>
                                      <option value="3">Prof. Dr.</option>
                                      <option value="4">Prof. Dr. Med.</option>
                                  </select>
                                  <label className="" data-error="" data-success="" id="TreatmentLabel">
                                      {this.state.lang.treatment_text}
                                  </label>
                              </div>
                              <MDBInput
                                  type="text"
                                  label={this.state.lang.firstname_text}
                                  name="first_name"
                                  onChange={this.handleFirstNameChange}
                                  className="form-control"
                                  required
                              />
                            <MDBInput
                                label={this.state.lang.middlename_text}
                                type="text"
                                name="middle_name"
                                onChange={this.handleMiddleNameChange}
                                className="form-control"
                            />
                              <MDBInput
                                  label={this.state.lang.lastname_text}
                                  type="text"
                                  name="last_name"
                                  onChange={this.handleLastNameChange}
                                  className="form-control"
                                  required
                              />
                              <MDBInput
                                  label={this.state.lang.jobtitle_text}
                                  type="text"
                                  name="job_title"
                                  onChange={this.handleJobTitleChange}
                                  className="form-control"
                              />
                              <label class="text-black-50 disabled" width="100%">{this.state.lang.birthdate_text}</label>
                              <div className="text-left mt-auto mb-3">
                                  <DatePicker
                                      class=""
                                      dateFormat="dd/MM/yyyy"
                                      timeZoneOffsetInMinutes={undefined}
                                      selected={this.state.selectedDate}
                                      onChange={this.handleBirthdateChange}
                                  />
                              </div>
                              <div class="row">
                                  <div class="col">
                                      <MDBInput
                                          label={this.state.lang.city_text}
                                          type="text"
                                          name="city"
                                          onChange={this.handleCityChange}
                                          className="form-control"
                                          required
                                      />
                                  </div>
                                  <div class="col">
                                      <MDBInput
                                          label={this.state.lang.postalcode_text}
                                          type="text"
                                          name="postal_code"
                                          onChange={this.handlePostalCodeChange}
                                          className="form-control"
                                          required
                                      />
                                  </div>
                              </div>
                              <MDBInput
                                  label={this.state.lang.primaryspecialty_text}
                                  type="text"
                                  name="primary_speciality"
                                  onChange={this.handlePrimarySpecialtyhange}
                                  className="form-control"
                              />

                              <div class="row">
                                  <div class="col-md-6 mb-4">
                                      <MDBInput
                                          type="text"
                                          label={this.state.lang.email_text}
                                          name="email"
                                          onChange={this.handleEmailChange}
                                          required
                                          className="form-control"
                                      />
                                  </div>
                                  <div class="col-md-6 mb-4">
                                      <MDBInput
                                          type="text"
                                          label={this.state.lang.secondemail_text}
                                          name="email"
                                          onChange={this.handleSecondEmailChange}
                                          required
                                          className="form-control"
                                      />
                                  </div>

                              </div>

                              <label htmlFor="defaultFormCardEmailEx" className="blue-text font-weight-light pequeña no-bottom">
                                  {this.state.lang.passwordinfo_text}
                              </label>
                              <div class="row">
                                  <div class="col">
                                      <MDBInput
                                          type="password"
                                          label={this.state.lang.password_text}
                                          name="password"
                                          onChange={this.handlePasswordChange}
                                          className="form-control no-top"
                                          required
                                      />
                                  </div>
                                  <div class="col">
                                      <MDBInput
                                          type="password"
                                          label={this.state.lang.secondpassword_text}
                                          name="password"
                                          onChange={this.handleSecondPasswordChange}
                                          required
                                      />
                                  </div>

                              </div>


                              <MDBInput
                                  label={this.state.lang.phone_text}
                                  type="text"
                                  name="phone"
                                  onChange={this.handlePhoneChange}
                                  className="form-control"
                              />

                            <div className="text-center mb-3">
                              <MDBBtn
                                  type="submit"
                                  value="Submit"
                                  gradient="blue"
                                  rounded
                                  className="btn-block z-depth-1a"
                                  id="submitButton"
                              >
                                  {this.state.lang.signin_text}
                              </MDBBtn>
                            </div>
                          </MDBCardBody>

                          <MDBModalFooter className="mx-5 pt-3 mb-1">
                            <p className="font-small grey-text d-flex justify-content-end muypequeña">
                              Developed by IST Medical
                            </p>
                          </MDBModalFooter>
                        </MDBCard>
                      </MDBCol>
                    </MDBRow>
                </MDBContainer>
              </form>
          </div>
          </div>
      );
    }

    base64_encode(data) {

        var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
            ac = 0,
            enc = '',
            tmp_arr = [];

        if (!data) {
            return data;
        }

        do { // pack three octets into four hexets
            o1 = data.charCodeAt(i++);
            o2 = data.charCodeAt(i++);
            o3 = data.charCodeAt(i++);

            bits = o1 << 16 | o2 << 8 | o3;

            h1 = bits >> 18 & 0x3f;
            h2 = bits >> 12 & 0x3f;
            h3 = bits >> 6 & 0x3f;
            h4 = bits & 0x3f;

            // use hexets to index into b64, and append result to encoded string
            tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
        } while (i < data.length);

        enc = tmp_arr.join('');

        var r = data.length % 3;

        return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
    }
    md5(str) {

        var xl;

        var rotateLeft = function(lValue, iShiftBits) {
            return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
        };

        var addUnsigned = function(lX, lY) {
            var lX4, lY4, lX8, lY8, lResult;
            lX8 = (lX & 0x80000000);
            lY8 = (lY & 0x80000000);
            lX4 = (lX & 0x40000000);
            lY4 = (lY & 0x40000000);
            lResult = (lX & 0x3FFFFFFF) + (lY & 0x3FFFFFFF);
            if (lX4 & lY4) {
                return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
            }
            if (lX4 | lY4) {
                if (lResult & 0x40000000) {
                    return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
                } else {
                    return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
                }
            } else {
                return (lResult ^ lX8 ^ lY8);
            }
        };

        var _F = function(x, y, z) {
            return (x & y) | ((~x) & z);
        };
        var _G = function(x, y, z) {
            return (x & z) | (y & (~z));
        };
        var _H = function(x, y, z) {
            return (x ^ y ^ z);
        };
        var _I = function(x, y, z) {
            return (y ^ (x | (~z)));
        };

        var _FF = function(a, b, c, d, x, s, ac) {
            a = addUnsigned(a, addUnsigned(addUnsigned(_F(b, c, d), x), ac));
            return addUnsigned(rotateLeft(a, s), b);
        };

        var _GG = function(a, b, c, d, x, s, ac) {
            a = addUnsigned(a, addUnsigned(addUnsigned(_G(b, c, d), x), ac));
            return addUnsigned(rotateLeft(a, s), b);
        };

        var _HH = function(a, b, c, d, x, s, ac) {
            a = addUnsigned(a, addUnsigned(addUnsigned(_H(b, c, d), x), ac));
            return addUnsigned(rotateLeft(a, s), b);
        };

        var _II = function(a, b, c, d, x, s, ac) {
            a = addUnsigned(a, addUnsigned(addUnsigned(_I(b, c, d), x), ac));
            return addUnsigned(rotateLeft(a, s), b);
        };

        var convertToWordArray = function(str) {
            var lWordCount;
            var lMessageLength = str.length;
            var lNumberOfWords_temp1 = lMessageLength + 8;
            var lNumberOfWords_temp2 = (lNumberOfWords_temp1 - (lNumberOfWords_temp1 % 64)) / 64;
            var lNumberOfWords = (lNumberOfWords_temp2 + 1) * 16;
            var lWordArray = new Array(lNumberOfWords - 1);
            var lBytePosition = 0;
            var lByteCount = 0;
            while (lByteCount < lMessageLength) {
                lWordCount = (lByteCount - (lByteCount % 4)) / 4;
                lBytePosition = (lByteCount % 4) * 8;
                lWordArray[lWordCount] = (lWordArray[lWordCount] | (str.charCodeAt(lByteCount) << lBytePosition));
                lByteCount++;
            }
            lWordCount = (lByteCount - (lByteCount % 4)) / 4;
            lBytePosition = (lByteCount % 4) * 8;
            lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80 << lBytePosition);
            lWordArray[lNumberOfWords - 2] = lMessageLength << 3;
            lWordArray[lNumberOfWords - 1] = lMessageLength >>> 29;
            return lWordArray;
        };

        var wordToHex = function(lValue) {
            var wordToHexValue = '',
                wordToHexValue_temp = '',
                lByte, lCount;
            for (lCount = 0; lCount <= 3; lCount++) {
                lByte = (lValue >>> (lCount * 8)) & 255;
                wordToHexValue_temp = '0' + lByte.toString(16);
                wordToHexValue = wordToHexValue + wordToHexValue_temp.substr(wordToHexValue_temp.length - 2, 2);
            }
            return wordToHexValue;
        };

        var x = [],
            k, AA, BB, CC, DD, a, b, c, d, S11 = 7,
            S12 = 12,
            S13 = 17,
            S14 = 22,
            S21 = 5,
            S22 = 9,
            S23 = 14,
            S24 = 20,
            S31 = 4,
            S32 = 11,
            S33 = 16,
            S34 = 23,
            S41 = 6,
            S42 = 10,
            S43 = 15,
            S44 = 21;

        str = this.utf8_encode(str);
        x = convertToWordArray(str);
        a = 0x67452301;
        b = 0xEFCDAB89;
        c = 0x98BADCFE;
        d = 0x10325476;

        xl = x.length;
        for (k = 0; k < xl; k += 16) {
            AA = a;
            BB = b;
            CC = c;
            DD = d;
            a = _FF(a, b, c, d, x[k + 0], S11, 0xD76AA478);
            d = _FF(d, a, b, c, x[k + 1], S12, 0xE8C7B756);
            c = _FF(c, d, a, b, x[k + 2], S13, 0x242070DB);
            b = _FF(b, c, d, a, x[k + 3], S14, 0xC1BDCEEE);
            a = _FF(a, b, c, d, x[k + 4], S11, 0xF57C0FAF);
            d = _FF(d, a, b, c, x[k + 5], S12, 0x4787C62A);
            c = _FF(c, d, a, b, x[k + 6], S13, 0xA8304613);
            b = _FF(b, c, d, a, x[k + 7], S14, 0xFD469501);
            a = _FF(a, b, c, d, x[k + 8], S11, 0x698098D8);
            d = _FF(d, a, b, c, x[k + 9], S12, 0x8B44F7AF);
            c = _FF(c, d, a, b, x[k + 10], S13, 0xFFFF5BB1);
            b = _FF(b, c, d, a, x[k + 11], S14, 0x895CD7BE);
            a = _FF(a, b, c, d, x[k + 12], S11, 0x6B901122);
            d = _FF(d, a, b, c, x[k + 13], S12, 0xFD987193);
            c = _FF(c, d, a, b, x[k + 14], S13, 0xA679438E);
            b = _FF(b, c, d, a, x[k + 15], S14, 0x49B40821);
            a = _GG(a, b, c, d, x[k + 1], S21, 0xF61E2562);
            d = _GG(d, a, b, c, x[k + 6], S22, 0xC040B340);
            c = _GG(c, d, a, b, x[k + 11], S23, 0x265E5A51);
            b = _GG(b, c, d, a, x[k + 0], S24, 0xE9B6C7AA);
            a = _GG(a, b, c, d, x[k + 5], S21, 0xD62F105D);
            d = _GG(d, a, b, c, x[k + 10], S22, 0x2441453);
            c = _GG(c, d, a, b, x[k + 15], S23, 0xD8A1E681);
            b = _GG(b, c, d, a, x[k + 4], S24, 0xE7D3FBC8);
            a = _GG(a, b, c, d, x[k + 9], S21, 0x21E1CDE6);
            d = _GG(d, a, b, c, x[k + 14], S22, 0xC33707D6);
            c = _GG(c, d, a, b, x[k + 3], S23, 0xF4D50D87);
            b = _GG(b, c, d, a, x[k + 8], S24, 0x455A14ED);
            a = _GG(a, b, c, d, x[k + 13], S21, 0xA9E3E905);
            d = _GG(d, a, b, c, x[k + 2], S22, 0xFCEFA3F8);
            c = _GG(c, d, a, b, x[k + 7], S23, 0x676F02D9);
            b = _GG(b, c, d, a, x[k + 12], S24, 0x8D2A4C8A);
            a = _HH(a, b, c, d, x[k + 5], S31, 0xFFFA3942);
            d = _HH(d, a, b, c, x[k + 8], S32, 0x8771F681);
            c = _HH(c, d, a, b, x[k + 11], S33, 0x6D9D6122);
            b = _HH(b, c, d, a, x[k + 14], S34, 0xFDE5380C);
            a = _HH(a, b, c, d, x[k + 1], S31, 0xA4BEEA44);
            d = _HH(d, a, b, c, x[k + 4], S32, 0x4BDECFA9);
            c = _HH(c, d, a, b, x[k + 7], S33, 0xF6BB4B60);
            b = _HH(b, c, d, a, x[k + 10], S34, 0xBEBFBC70);
            a = _HH(a, b, c, d, x[k + 13], S31, 0x289B7EC6);
            d = _HH(d, a, b, c, x[k + 0], S32, 0xEAA127FA);
            c = _HH(c, d, a, b, x[k + 3], S33, 0xD4EF3085);
            b = _HH(b, c, d, a, x[k + 6], S34, 0x4881D05);
            a = _HH(a, b, c, d, x[k + 9], S31, 0xD9D4D039);
            d = _HH(d, a, b, c, x[k + 12], S32, 0xE6DB99E5);
            c = _HH(c, d, a, b, x[k + 15], S33, 0x1FA27CF8);
            b = _HH(b, c, d, a, x[k + 2], S34, 0xC4AC5665);
            a = _II(a, b, c, d, x[k + 0], S41, 0xF4292244);
            d = _II(d, a, b, c, x[k + 7], S42, 0x432AFF97);
            c = _II(c, d, a, b, x[k + 14], S43, 0xAB9423A7);
            b = _II(b, c, d, a, x[k + 5], S44, 0xFC93A039);
            a = _II(a, b, c, d, x[k + 12], S41, 0x655B59C3);
            d = _II(d, a, b, c, x[k + 3], S42, 0x8F0CCC92);
            c = _II(c, d, a, b, x[k + 10], S43, 0xFFEFF47D);
            b = _II(b, c, d, a, x[k + 1], S44, 0x85845DD1);
            a = _II(a, b, c, d, x[k + 8], S41, 0x6FA87E4F);
            d = _II(d, a, b, c, x[k + 15], S42, 0xFE2CE6E0);
            c = _II(c, d, a, b, x[k + 6], S43, 0xA3014314);
            b = _II(b, c, d, a, x[k + 13], S44, 0x4E0811A1);
            a = _II(a, b, c, d, x[k + 4], S41, 0xF7537E82);
            d = _II(d, a, b, c, x[k + 11], S42, 0xBD3AF235);
            c = _II(c, d, a, b, x[k + 2], S43, 0x2AD7D2BB);
            b = _II(b, c, d, a, x[k + 9], S44, 0xEB86D391);
            a = addUnsigned(a, AA);
            b = addUnsigned(b, BB);
            c = addUnsigned(c, CC);
            d = addUnsigned(d, DD);
        }

        var temp = wordToHex(a) + wordToHex(b) + wordToHex(c) + wordToHex(d);

        return temp.toLowerCase();
    }
    utf8_encode(argString) {
        if (argString === null || typeof argString === 'undefined') {
            return '';
        }

        var string = (argString + ''); // .replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        var utftext = '',
            start, end, stringl = 0;

        start = end = 0;
        stringl = string.length;
        for (var n = 0; n < stringl; n++) {
            var c1 = string.charCodeAt(n);
            var enc = null;

            if (c1 < 128) {
                end++;
            } else if (c1 > 127 && c1 < 2048) {
                enc = String.fromCharCode(
                    (c1 >> 6) | 192, (c1 & 63) | 128
                );
            } else if ((c1 & 0xF800) != 0xD800) {
                enc = String.fromCharCode(
                    (c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128
                );
            } else { // surrogate pairs
                if ((c1 & 0xFC00) != 0xD800) {
                    throw new RangeError('Unmatched trail surrogate at ' + n);
                }
                var c2 = string.charCodeAt(++n);
                if ((c2 & 0xFC00) != 0xDC00) {
                    throw new RangeError('Unmatched lead surrogate at ' + (n - 1));
                }
                c1 = ((c1 & 0x3FF) << 10) + (c2 & 0x3FF) + 0x10000;
                enc = String.fromCharCode(
                    (c1 >> 18) | 240, ((c1 >> 12) & 63) | 128, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128
                );
            }
            if (enc !== null) {
                if (end > start) {
                    utftext += string.slice(start, end);
                }
                utftext += enc;
                start = end = n + 1;
            }
        }

        if (end > start) {
            utftext += string.slice(start, stringl);
        }

        return utftext;
    }
    unicode_encode(theString) {
        var unicodeString = '';
        for (var i=0; i < theString.length; i++) {
            var theUnicode = theString.charCodeAt(i).toString(16).toUpperCase();
            while (theUnicode.length < 4) {
                theUnicode = '0' + theUnicode;
            }
            theUnicode = '\\u' + theUnicode;
            unicodeString += theUnicode;
        }
        return unicodeString;
    }
    codificarValor(codificacion,valor) {

        if(codificacion != null) {
            var arrayCode = codificacion.split(",");
            var i=0;
            for(i=0;i <= arrayCode.length;i++) {
                switch(arrayCode[i]) {
                    case 'md5':
                        valor = this.md5(valor);
                        break;
                    case 'base64':
                        valor = this.base64_encode(valor);
                        break;
                    case 'unicode':
                        valor = this.unicode_encode(valor);
                        break;
                }
            }
        }

        return valor;
    }
    decodificarValor(codificacion,valor){
        if(codificacion != null) {
            var arrayCode = codificacion.split(",");
            var i=0;
            for(i=0;i <= arrayCode.length;i++) {
                switch(arrayCode[i]) {
                    case 'md5':
                        valor = this.md5(valor);
                        break;
                    case 'base64':
                        valor = this.base64_decode(valor);
                        break;
                    case 'unicode':
                        //valor = this.unicode_decode(valor);
                        break;
                }
            }
        }

        return valor;
    }
    base64_decode(valor){

        var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        var output = "";
        var chr1, chr2, chr3 = "";
        var enc1, enc2, enc3, enc4 = "";
        var i = 0;

        // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
        var base64test = /[^A-Za-z0-9\+\/\=]/g;
        if (base64test.exec(valor)) {
            alert("There were invalid base64 characters in the input text.\n" +
                "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
                "Expect errors in decoding.");
        }
        valor = valor.replace(/[^A-Za-z0-9\+\/\=]/g, "");

        do {
            enc1 = b64.indexOf(valor.charAt(i++));
            enc2 = b64.indexOf(valor.charAt(i++));
            enc3 = b64.indexOf(valor.charAt(i++));
            enc4 = b64.indexOf(valor.charAt(i++));

            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;

            output = output + String.fromCharCode(chr1);

            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }

            chr1 = chr2 = chr3 = "";
            enc1 = enc2 = enc3 = enc4 = "";

        } while (i < valor.length);

        return unescape(output);
    }

    parseSqlError(data){
        var errorCodeMsg = data.logMessages[data.logMessages.length -1];
        var errorCode = (errorCodeMsg.replace("[SQL_ERR_Code] - ","")).trim();

        if(errorCode == 1062){
            return "Doctor KV already exists. Have you forgotten your credentials?";
        }else{
            return data.message;
        }
    }
}

export default RegistroDoctoresForm;

